import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Container, Row } from '@yme/atoms/grid';
import { IndentWrapper } from '@yme/components/Separator';
import { getRTL } from '@yme/selectors/common';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeadingLevel2 } from '@yme/tokens/typography';
import { buildKey } from '@yme/utils/common';
import { TeaserCard } from './TeaserCard';
export function Teasers(props) {
    const { title, teasers, isRemoveBottomIndent } = props;
    const isRightToLeft = useSelector(getRTL);
    if (teasers?.length === 0) {
        return null;
    }
    const cards = teasers?.map((card, index) => (React.createElement(TeaserCard, { cardProps: card, key: buildKey(index, card.title) })));
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(Container, { isRightToLeft: isRightToLeft },
            React.createElement(Row, { justifyContent: "center" },
                React.createElement(Col, { lg: 8 },
                    title && (React.createElement(FlexWrapper, { mbDesktop: "32px", mbTablet: "24px", mbMobile: "16px" },
                        React.createElement(HeadingLevel2, null, title))),
                    cards)))));
}
